import styled from 'styled-components';

export const EnrichModal = styled.div`
  position: relative;

  .enrich-holder {
    text-align: center;

    .img-holder {
      margin: 0 0 30px;
    }

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      color: var(--text-color-50);
      margin: 0 0 10px;
    }

    .text {
      display: block;
      margin: 0 0 35px;
    }

    .btn-holder {
      display: flex;
      gap: 15px;
    }
  }
`;
